<div class="ipm-files">
  <div class="ipm-files__data">
    @if (dataLoaded) {
      <div class="ipm-files__data-container">
        <button mat-raised-button class="ipm-files__btn" (click)="downloadZip()" [disabled]="downloadBtnDisabled()">
          {{ 'fileList.download' | translate }}
        </button>
        <table mat-table [dataSource]="filesDataSource" matSort #filesSorter="matSort" class="ipm-files__list">
          <!-- Select Column -->
          <ng-container matColumnDef="Select">
            <th mat-header-cell *matHeaderCellDef class="ipm-files__list-select">
              <mat-checkbox
                (change)="masterToggle(FileType.File)"
                [checked]="selectionHasValue(FileType.File) && isAllSelected(FileType.File)"
                [indeterminate]="selectionHasValue(FileType.File) && !isAllSelected(FileType.File)"
                [aria-label]="checkboxLabel(FileType.File)"
              >
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row" class="ipm-files__list-select" (click)="selectionToggle(FileType.File, row)">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? selectionToggle(FileType.File, row) : null"
                [checked]="isSelected(FileType.File, row)"
                [aria-label]="checkboxLabel(row)"
              >
              </mat-checkbox>
            </td>
          </ng-container>
          <!-- Name Column -->
          <ng-container matColumnDef="fileName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="ipm-files__list-name">{{ 'fileList.files' | translate }}</th>
            <td mat-cell *matCellDef="let element" (click)="open(element)" class="ipm-files__list-name">
              {{ element.fileName }}
            </td>
          </ng-container>
          <!-- Timestamp Column -->
          <ng-container matColumnDef="updatedOnUtc">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="ipm-files__list-timestamp">
              {{ 'fileList.timestamp' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" (click)="open(element)" class="ipm-files__list-timestamp">
              {{ element.updatedOnUtc | customDate: 'medium' }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columns"></tr>
          <tr mat-row *matRowDef="let row; columns: columns" class="ipm-files__list-row"></tr>
        </table>
      </div>
    } @else {
      <osc-utils-spinner class="ipm-files__spinner" #filesSpinner [spinnerId]="filesSpinnerId"></osc-utils-spinner>
    }
  </div>
</div>

<ng-template #spinner>
  <osc-utils-spinner class="ipm-files__spinner" #filesSpinner [spinnerId]="filesSpinnerId"></osc-utils-spinner>
</ng-template>
